import React from 'react';
import withRoot from "../../../withRoot";
import CheckoutEmision from "./Checkout";
import { useHistory } from "react-router-dom";
import useStyles from "../VehiculoForm/Checkout/styles";
import Header from "../../../adviser/Dashboard/Header";
import Title from "../../../customer/ProductsCustomer/Title";
import ByPolko from "../../../customer/ByPolko";
import {useMediaQuery} from "react-responsive";

function Emision(props) {
    const classes = useStyles();
    const history = useHistory();
    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",

    });

    return (
        <React.Fragment>
            <div className={classes.divBackground}>

                <div className={classes.divHeader}>
                    <Header role={"Asesor"}/>
                </div>

                <div className={classes.divTitle}>
                    <Title
                        title={"SEGUROS"}
                        subtitle={"¡Emita un seguro de hogar en 3 simples pasos!"}
                    />
                </div>

                <div className={classes.formBox}>
                    {typeof props.location.state !== 'undefined'
                        ? (<CheckoutEmision
                            continueCotizacion={true}
                            additionalStep={props.location.state.emisionValues.additionalStep}
                            emisionValues={props.location.state.emisionValues}
                            idCotizacion={props.location.state.idCotizacion}
                            isMobile={isMobileDevice}
                        />)
                        : history.push('/u/dashboard')}
                </div>

                <div className={classes.divByPolko}>
                    <ByPolko fontSize={25}/>
                </div>
            </div>
        </React.Fragment>
    )
}
export default withRoot(Emision);
